import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/utils/utils";
import { LucideIcon } from "lucide-react";

interface StatCardProps {
    title: string;
    value: string | number;
    icon: LucideIcon;
    description?: React.ReactNode;
    trend?: {
        value: number;
        isPositive: boolean;
    };
    className?: string;
}

export function StatCard({
                             title,
                             value,
                             icon: Icon,
                             description,
                             trend,
                             className,
                         }: StatCardProps) {
    return (
        <Card className={cn("transition-all hover:shadow-md", className)}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium text-muted-foreground">
                    {title}
                </CardTitle>
                <Icon className="h-4 w-4 text-muted-foreground" />
            </CardHeader>

            <CardContent>
                <div className="text-2xl font-bold">{value}</div>

                {description ? (
                    <div className="text-xs text-muted-foreground mt-1">{description}</div>
                ) : null}

                {trend ? (
                    <div
                        className={cn(
                            "text-xs mt-1 font-medium",
                            trend.isPositive ? "text-success" : "text-destructive"
                        )}
                    >
                        {trend.isPositive ? "+" : "-"}
                        {trend.value}% от прошлого месяца
                    </div>
                ) : null}
            </CardContent>
        </Card>
    );
}
